import { jsx as _jsx } from "react/jsx-runtime";
import { AuthProvider } from "./auth-context";
export var AppProviders = function (_a) {
    var children = _a.children;
    return _jsx(AuthProvider, { children: children });
};
